import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import type { ImprintPage } from '../../api/api-types';
import type { Loadable } from '../../guards/ngrx-loader.guard';
import { actions } from './imprint.actions';

interface ImprintState {
    content: Loadable<ImprintPage>;
}

const initialState: ImprintState = {
    content: null,
};

export const state = createFeature({
    name: 'imprint',
    reducer: createReducer(
        initialState,
        on(
            actions.loadDealerImprintSuccess,
            (state, { imprint }): ImprintState => ({
                ...state,
                content: imprint,
            }),
        ),
        on(
            actions.loadDealerImprintFailure,
            (state): ImprintState => ({
                ...state,
                content: false,
            }),
        ),
    ),
    extraSelectors: (baseSelectors) => {
        const selectIsLoadingContent = createSelector(baseSelectors.selectContent, (content) => content === null);
        const selectLoadedContent = createSelector(baseSelectors.selectContent, (content) => content as ImprintPage);

        return {
            selectIsLoadingContent,
            selectLoadedContent,
        };
    },
});
